import React, { Component } from 'react'
import WeclomeAction from '../sections/website/Welcome/action'
import { observer, inject } from 'mobx-react'
import { withRouter, Link } from 'react-router'
import classnames from 'classnames'

@withRouter
@inject('welcome')
@observer
export default class WelcomeActionBanner extends Component {

  state = {
    showingVideo: false
  }

  handleDone = action => event => {
    event.preventDefault()
    this.props.welcome.update(action.key)
  }

  handleVideo = event => {
    event.preventDefault()
    let { showingVideo } = this.state
    showingVideo = !showingVideo
    this.setState({ showingVideo })
  }

  videoButton(action) {
    if (action.video) {
      return (
        <a className="video button" href="#" onClick={this.handleVideo}>Watch Tutorial</a>
      )
    }
  }

  primaryButton(action) {
    if (action.complete) {
      const { welcome } = this.props
      const next = welcome.activeAction
      if (!next) return null
      return (
        <Link className="primary button" to={welcome.getActionLinkUrl(next)}>Next</Link>
      )
    } else {
      return (
        <a className="primary button" href="#" onClick={this.handleDone(action)}>Done</a>
      )
    }
  }

  videoPlayer(action) {
    if (action.video) {
      return (
        <div className={classnames('welcome-video', { open: this.state.showingVideo })}>
          <iframe src={`https://player.vimeo.com/video/${action.video}`}
          width="640" height="360"
          frameBorder="0" allowFullScreen />
        </div>
      )
    }
  }

  render() {

    if (!this.props.welcome || !this.props.welcome.website) return null

    const { state={} } = this.props.router.location
    const { welcome_action } = state

    if (!welcome_action) return null

    const { welcome } = this.props

    const action = welcome.actions.find(act => act.key === welcome_action)

    return (
      <div className="welcome-banner">
        <WeclomeAction {...action} active={true}>
          {this.videoButton(action)}
          <Link className="button" to={`/website/${welcome.website.id}/welcome`}>Back</Link>
          {this.primaryButton(action)}
        </WeclomeAction>
        {this.videoPlayer(action)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/navigation/WelcomeActionBanner.js